import {Button} from '@chekinapp/ui';
import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';

export const Wrapper = styled.div`
  padding: 40px 24px;
  @media (min-width: ${DEVICE.laptop}) {
    padding: 24px 24px 0;
  }
`;

export const Container = styled.div`
  max-width: 522px;
  margin: 0 auto;

  & .box-info {
    max-width: 327px;
    margin: 0 auto 24px;
  }
`;

export const StyledButton = styled(Button)`
  width: 100%;
  max-width: 327px;
  margin: 0 auto;
`;
